import { render, staticRenderFns } from "./CompanyCommunity.vue?vue&type=template&id=ed0c714e&"
import script from "./CompanyCommunity.vue?vue&type=script&lang=js&"
export * from "./CompanyCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports